export default
  mounted: ->
    return unless (this != @$root); # guard against running this in the root component.
    @autosize()
    @_resizeHandler = =>
      clearTimeout(@_resizeTimer)
      @_resizeTimer = setTimeout((=> @autosize()), 100)
    window.addEventListener 'resize', @_resizeHandler
  updated: ->
    return unless (this != @$root); # guard against running this in the root component.
    @autosize()
  beforeDestroy: ->
    clearTimeout(@_resizeTimer)
    window.removeEventListener('resize', @_resizeHandler) if @_resizeHandler
  methods:
    autosize: (id) ->
      return @autosizeClass() unless id
      @autosizeId(id)
    autosizeClass: (classname) ->
      return unless (@$el?.querySelectorAll?) # guard against components with top-level v-if. comments don't have querySelectorAll
      classname = 'autosize' unless classname
      elements = @$el.querySelectorAll(".#{classname}") # restrict this action to just those in this component      
      elements = Array.from(elements)
      if elements.length <= 0
        return
      elements.forEach (element) =>
        @autosizeElement(element)
    autosizeId: (id) ->
      element = document.getElementById(id)      
      @autosizeElement(element)
    autosizeElement: (element) ->
      return unless element
      # Don't bother with invisible elements.
      return if (element.offsetWidth <= 0 || element.offsetHeight <= 0)

      tries = 32 # number of tries, equal to 32 pixels of shrink.
      ratio = 1 # Amount to reduce the font by each try.
      minimum = 13 # minimum font size

      # Store the initial size to restore on change.
      elementStyle = window.getComputedStyle(element)
      initialSize = elementStyle.getPropertyValue('font-size')
      if !(element.hasAttribute('data-autosize-initial-font-size'))
        element.setAttribute('data-autosize-initial-font-size', initialSize)
      if !(element.getAttribute('data-autosize-initial-font-size') == initialSize)
        element.style.fontSize = element.getAttribute('data-autosize-initial-font-size')

      q = 0 # Bailout counter.
      while ((element.scrollWidth > element.offsetWidth || element.scrollHeight > element.offsetHeight) && (q < tries))
        q++
        oldFontSize = elementStyle.getPropertyValue('font-size')
        floatFontSize = parseFloat(oldFontSize)
        break if floatFontSize <= minimum
        fontUnit = "px"
        newFontSize = (floatFontSize - ratio) + "" + fontUnit
        element.style.fontSize = newFontSize
        element.setAttribute('data-autosize-font-size', newFontSize)
